<template>
  <div class="c-profile-form">
    <FormulateForm
      ref="form"
      v-if="profile"
      v-model="profile"
      @submit="save"
      @submit-raw="checkValidation"
      :errors="errors"
    >
      <FormulateInput
        name="picture"
        type="image"
        :validation-messages="{
          mime: 'Kies een jpeg afbeelding'
        }"
        @file-upload-complete="uploadedAvatar"
        @file-removed="removedAvatar"
      />

      <FormulateInput
        name="first_name"
        label="Voornaam"
        validation-name="Voornaam"
        validation="required"
      />
      <FormulateInput
        name="last_name"
        label="Achternaam"
        validation-name="Achternaam"
        validation="required"
      />
      <FormulateInput
        name="email"
        label="Email"
        validation-name="Email"
      />
      <FormulateInput
        name="mobile"
        label="Telefoon"
        validation-name="Telefoon"
        :validation="mobileRequired"
      />
      <FormulateInput
        type="radio"
        name="gender"
        :options="{m: 'Man', f: 'Vrouw', u: 'X'}"
      />

      <FormulateInput
        name="street"
        label="Straat"
        validation-name="Straat + nummer"
      />
      <div class="c-house-number">
        <FormulateInput
          name="house_number"
          label="Huisnummer"
          validation-name="Huisnummer"
        />
        <FormulateInput
          name="house_number_suffix"
          label="Toevoeging"
          validation-name="Toevoeging"
        />
      </div>
      <FormulateInput
        name="zip"
        label="Postcode"
        validation-name="Postcode"
        validation="required"
      />
      
      <FormulateInput
        name="city"
        label="Woonplaats"
        validation-name="Woonplaats"
        validation="required"
      />

      <CountrySelect v-model="profile.country"></CountrySelect>

      <FormulateInput
        type="date"
        name="birthday"
        label="Ik ben geboren op"
      />
      <FormulateInput
        type="checkbox"
        name="opt_ins"
        :options="optIns"
        v-if="optIns"
      />
      <div v-if="saved" class="c-alert-success">
        Uw gegevens werden aangepast!
      </div>
      <div v-if="error" class="c-alert-fail">
        Er liep iets mis... Probeer nogmaals.
      </div>
      <div v-if="invalid || invalidHtmlInput" class="c-alert-fail">
        Vul je gegevens aan.
      </div>
      <footer class="o-section__footer u-center">
        <button class="c-button" v-if="loading" disabled> BEZIG MET OPSLAAN...</button>
        <button class="c-button" v-else>OPSLAAN</button>
      </footer>
    </FormulateForm>
    <div v-else>
      We laden je gegevens in...
    </div>
  </div>
</template>


<script>
  import authentication from '@general/authentication'
  import CountrySelect from './CountrySelect';
  import settings from '@config/site.yml?path=site.{rails_env}.public'

  export default {
    name: 'ProfileForm',
    data() {
      return {
        loading: false,
        errors: {},
        saved: false,
        error: false,
        invalidHtmlInput: false,
        profile: null
      }
    },
    components: {
      CountrySelect
    },
    computed: {
      optIns() {
        return settings.opt_ins
      },
      invalid() {
        return Object.keys(this.errors).length
      },
      mobileRequired() {
        return settings.stationId === 'qmusic_nl' ? 'required' : 'optional'
      }
    },
    mounted() {
      authentication.onLogin(async () => {
        await this.$store.dispatch('user/fetchProfile');
        const profile = Object.assign({}, this.$store.state.user.profile);
        if (settings.localPhoneNumberPrefix) {
          profile.mobile &&= profile.mobile.replace(`${settings.localPhoneNumberPrefix}.`, '0')
        }
        profile.mobile &&= profile.mobile.replace('.', '')
        if (profile.user_picture) {
          profile.picture = [{ url: profile.user_picture.thumb_url }]
        }
        this.profile = profile
      })
    },
    methods: {
      uploadedAvatar() {
        this.profile.picture.new = true
        this.profile.picture.delete = false
      },
      removedAvatar() {
        this.profile.picture.new = false
        this.profile.picture.delete = true
      },
      removeErrors(){
        this.invalidHtmlInput = false
        this.saved = false
        this.error = false
        this.errors = {}
      },
      checkValidation() {
        this.removeErrors()
        this.invalidHtmlInput =
          this.$refs.form.$children.some(
            (input) => typeof input.isValid !== 'undefined' && !input.isValid
          )
      },
      async save() {
        this.removeErrors()
        this.loading = true
        try {
          await this.$store.dispatch('user/save', this.profile)
          this.saved = true
        } catch({response: {status, data} = {}}) {
          if(status === 422) {
            this.errors = data.errors
          } else {
            this.error = true
          }
        }
        this.loading = false
      }
    }
  };
</script>
